import { FunctionComponent, useState } from "react";
import "./PlayerStatistic.css"


export type PlayerGroup = "total" | "online" | "offline" | "withAssignedChannel" | "withoutChannel";

interface PlayerStatisticProps {
    activeGroup: PlayerGroup,
    total: number,
    online: number,
    offline: number,
    assignedPlayers: number,
    unassignedPlayers: number,
    onClickFunction: (playerGroup: PlayerGroup) => void 
}

interface StatisticElementProps {
    group: PlayerGroup,
    count: number,
    text: string
}
 
const PlayerStatistic: FunctionComponent<PlayerStatisticProps> = (props) => {

    let {activeGroup, total, online, offline, assignedPlayers, unassignedPlayers, onClickFunction} = props;

    const checkStatus = (status:PlayerGroup) => status === activeGroup ? "active" : "";

    const StatisticElement: FunctionComponent<StatisticElementProps> = (props) => {
        let { group, count, text} = props;
        return(
            <div className={`player-statistic__elem ${checkStatus(group)}`} onClick={()=>onClickFunction(group)}>
                <span className={`${group}-span`}>{count}</span>
                <p>{text}</p>
            </div>
        )
    }

    return (
        <div className="player-statistic">
            <StatisticElement group="total" count={total} text="Total Active Players"/>
            <StatisticElement group="online" count={online} text="Players Online"/>
            <StatisticElement group="offline" count={offline} text="Players Offline"/>
            <StatisticElement group="withAssignedChannel" count={assignedPlayers} text="Assigned Players"/>
            <StatisticElement group="withoutChannel" count={unassignedPlayers} text="Unassigned Players"/>
        </div>
    );
}

 
export default PlayerStatistic;